import { Component, ElementRef, ViewContainerRef, ChangeDetectionStrategy, QueryList, Renderer2, Injector, ValueProvider, ContentChild } from '@angular/core';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { Pager } from '@syncfusion/ej2-grids';
import { Template } from '@syncfusion/ej2-angular-base';


export const /** @type {?} */ inputs: string[] = ['currentPage','customText','enableExternalMessage','enablePagerMessage','enablePersistence','enableQueryString','enableRtl','externalMessage','locale','pageCount','pageSize','pageSizes','template','totalRecordsCount'];
export const /** @type {?} */ outputs: string[] = ['click','created','dropDownChanged'];
export const /** @type {?} */ twoWays: string[] = [];
/**
 * `ejs-pager` represents the Angular Pager Component.
 * ```html
 * <ejs-pager></ejs-pager>
 * ```
 */
@ComponentMixins([ComponentBase])
export class PagerComponent extends Pager implements IComponentBase {
public context : any;
public tagObjects: any;
/**
 *  Defines the template as string or HTML element ID which renders customized elements in pager instead of default elements.
 * \@default null
 */
@Template()
    public template: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.context  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.context.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.context.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.context.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.context.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-pager',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'template': [{ type: ContentChild, args: ['template', ] },],
};
}

function PagerComponent_tsickle_Closure_declarations() {
/** @type {?} */
PagerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PagerComponent.ctorParameters;
/** @type {?} */
PagerComponent.propDecorators;
/** @type {?} */
PagerComponent.prototype.context;
/** @type {?} */
PagerComponent.prototype.tagObjects;
/**
 *  Defines the template as string or HTML element ID which renders customized elements in pager instead of default elements.
 * \@default null
 * @type {?}
 */
PagerComponent.prototype.template;
/** @type {?} */
PagerComponent.prototype.registerEvents;
/** @type {?} */
PagerComponent.prototype.addTwoWay;
/** @type {?} */
PagerComponent.prototype.ngEle;
/** @type {?} */
PagerComponent.prototype.srenderer;
/** @type {?} */
PagerComponent.prototype.viewContainerRef;
/** @type {?} */
PagerComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
